import KeywordExtensionCard from './KeywordExtensionCard';
import './KeywordExtensionCard.scss';

export default KeywordExtensionCard;
